import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Keep <html lang> in step so browsers and screen readers treat the text correctly.
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'km', 'zh'],
    debug: false,
    resources: messages,
    // Only a language the person chose is restored; first visits stay English.
    detection: { order: ['localStorage'], caches: ['localStorage'], lookupLocalStorage: 'loyalty_language' },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
